import { Route } from '@angular/router';
import { UspvsCheckComponent } from './uspvs-check.component';

export const UspvsRoutes: Route[] = [
    {
        path: 'uspvs/:LegacySequenceNumber', component: UspvsCheckComponent
    }
];
